import React, { useState } from "react";
import { Button, Modal, Input, message } from "antd";
import { gql, useMutation } from "@apollo/client";

const CINFIRMUSER = gql`
  mutation confirmUser($id: ID!, $confirmUserInput: ConfirmInput!) {
    confirmUser(id: $id, confirmInput: $confirmUserInput)
  }
`;

function RejectProfile({ id, disabled, children, onUpdateUser }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState(null);

  const [runConfirmUser, confirmUser] = useMutation(CINFIRMUSER, {
    onCompleted(data) {
      message.success("پروفایل کاربر رد شد.");
      setIsModalOpen(false);
      onUpdateUser()
    },
    onError(err) {
      console.log("خطا: " + err.message);
      message.error("مشکلی پیش آمده!!!");
    },
  });

  const doRejectUser = () => {
    const confirmUserInput = {
      confirmMessage: confirmMessage ? confirmMessage : "پروفایل شما تایید نشد",
      confirmStatus: "ERROR",
    };
    runConfirmUser({
      variables: { id, confirmUserInput },
    });
  };
  const { TextArea } = Input;
  return (
    <div>
      <Button onClick={() => setIsModalOpen(true)} danger disabled={disabled}>
        {children}
      </Button>
      <Modal
        title="دلیل رد پروفایل:"
        open={isModalOpen}
        onOk={doRejectUser}
        okButtonProps={{
          disabled: false,
          loading: confirmUser.loading && true,
        }}
        onCancel={() => setIsModalOpen(false)}
        cancelButtonProps={{ disabled: false }}
        okText="رد پروفایل"
        cancelText="انصراف"
      >
        <TextArea
          rows={4}
          placeholder=" لطفا حداکثر 150 کاراکتر وارد کنید."
          maxLength={150}
          disabled={false}
          onChange={(e) => setConfirmMessage(e.target.value)}
        />
      </Modal>
    </div>
  );
}

export default RejectProfile;
